module.exports = __webpack_public_path__ + "static/media/card-vps-n8n-br.c2195356.png";